module.exports = "# Sizzle\n\n## Content\n\n### Activité: Créer un sketch!\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Instructions\n* Dans votre sketch, vous et quelques amis jouissez d'une activité aquatique lorsque vous remarquez quelqu'un qui nuit à l'eau.\n* Vous réussissez à le convaincre poliment de devenir un gardien de la planète et de protéger l'eau.\n* Répétez votre sketch en équipe (10 min.) et présentez-le à la classe!\n\n## Notes\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/sections/30_classActivity/level4_skit.fr_CA.md
// module id = 1703
// module chunks = 2